import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../../shared';
import { ArquivoExtensaoPipeModule } from '../../../../extensoes/pipes';

import { ArquivoUploadTableComponent } from './arquivo-upload-table.component';

@NgModule({
    imports: [
        SharedModule,
        ArquivoExtensaoPipeModule
    ],
    declarations: [
        ArquivoUploadTableComponent
    ],
    exports: [
        ArquivoUploadTableComponent
    ]
})
export class ArquivoUploadTableModule { }
